// display date formats come from getOrganizationDateFormats, these are picker input formats, time formats, and serialization anchors
export const DATE_FORMAT = "MM/dd/yyyy";
export const MONTH_YEAR_FORMAT = "MM/yyyy";
export const MONTH_DAY_DATE_FORMAT = "MM/dd";
export const TIME_FORMAT_12_HOUR = "hh:mm a";
export const TIME_FORMAT_24_HOUR = "HH:mm:ss";
export const DATE_TIME_FORMAT = "MM/dd/yyyy hh:mm a";

export const ISO_DATE_FORMAT = "yyyy-MM-dd";

export const MOBILE_MEDIA_QUERY = "@media screen and (min-width: 99999px)";
